import React, { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import ModalPortal from '../../../components/common/ModalPortal';
import { Button } from '../../../components/common/Button';

interface ShortInterviewWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ShortInterviewWarningModal: React.FC<ShortInterviewWarningModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const maintainMediaTracks = () => {
      const videoEl = document.querySelector('video');
      if (videoEl && videoEl.srcObject instanceof MediaStream) {
        const mediaStream = videoEl.srcObject;
        mediaStream.getTracks().forEach((track) => {
          console.log(
            `[ShortInterviewWarningModal] Preserving ${track.kind} track state: ${track.enabled ? 'enabled' : 'disabled'}`,
          );
        });
      }
    };

    maintainMediaTracks();
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm();
  };

  if (!isOpen) return null;

  return (
    <ModalPortal>
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in z-[100]">
        <div className="bg-surface-light dark:bg-surface-dark rounded-xl shadow-xl max-w-md w-full border border-border-light dark:border-border-dark animate-fade-in-up">
          <div className="p-5 border-b border-border-light dark:border-border-dark">
            <div className="flex items-center">
              <div className="p-2 rounded-full bg-amber-500/15 mr-3">
                <AlertTriangle className="w-5 h-5 text-amber-500" />
              </div>
              <h3 className="text-lg font-semibold text-text-primary-light dark:text-text-primary-dark">
                Interview Seems Too Short
              </h3>
            </div>
          </div>
          <div className="p-5">
            <p className="text-base text-text-secondary-light dark:text-text-secondary-dark mb-4">
              You&apos;ve spent less than 5 minutes in this interview. Ending now may result in limited
              feedback and incomplete analysis.
            </p>

            <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
              <Button
                variant="outline"
                onClick={onClose}
                className="w-full sm:w-auto"
              >
                Continue Interview
              </Button>
              <Button
                variant="primary"
                onClick={handleConfirm}
                className="w-full sm:w-auto text-text-primary-dark dark:text-text-primary-dark !bg-amber-500 hover:!bg-amber-600 !border-amber-500 !shadow-amber-500/30"
              >
                Yes, End Anyway
              </Button>
            </div>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default ShortInterviewWarningModal;
